import { inject, Injectable } from '@angular/core';
import { has } from 'lodash';
import { Store } from '@ngrx/store';

import { getPartner } from '../../@store/partner/partner.selectors';
import { filter, map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  readonly #store = inject(Store);
  readonly #partnerData$ = this.#store.select(getPartner).pipe(
    filter((partner) => !!partner),
    take(1)
  );

  partnerData: ReturnType<typeof getPartner>;

  constructor(private store: Store) {
    this.store
      .select(getPartner)
      .pipe(
        filter((p) => !!p),
        take(1)
      )
      .subscribe((_partner) => {
        this.partnerData = _partner;
      });
  }

  getAllFeatures$() {
    return this.#partnerData$.pipe(
      filter(partnerData => !!partnerData),
      map(partnerData => partnerData.feature_flags)
    )
  }

  /**
   * @deprecated Use Observable function isFeatureAllowed$() instead!
   *
   * determines if a feature is allowed
   */
  isFeatureAllowed(feature: string): boolean {
    if (
      this.partnerData &&
      has(this.partnerData, 'feature_flags') &&
      has(this.partnerData.feature_flags, feature)
    ) {
      return this.partnerData.feature_flags[feature];
    }

    return false;
  }

  isFeatureAllowed$(feature: string): Observable<boolean> {
    return this.#partnerData$.pipe(
      map((partner) => has(partner?.feature_flags, feature))
    );
  }
}
